class ForgotPasswordController {
    static $inject = ["stToast", "tpsrService"];

    constructor(stToast, tpsrService) {
        this.toast = stToast;
        this.tpsr = tpsrService;

        this.user = {
            email: null
        };
        this.emailSent = false;
    }

    $onInit() {
    }

    sendEnabled = () => {
        if (!this.user.email)
            return false;

        if (this.emailSent)
            return false;

        return true;
    };

    sendClicked = () => {
        this.emailSent = true;
        return this.tpsr.resetPasswordRequest({ email: this.user.email })
            .then(result => {
                
            });
    };
}

angular
    .module("app")
    .component("forgotPassword", { // forgot-password
        templateUrl: "src/app/account/forgotPassword/forgotPassword.html",
        controller: ForgotPasswordController
    });
